import React, { useCallback } from "react";
import { ICONS } from "../../../assets/icons";
import { conversationSummaryList } from "../constants/index";
import FilterHome from "../../../components/commonComponents/filterHome/FilterHome";
import { HomeFilterList } from "../../../constant/app/Filter/Filter";
import { Tooltip } from "antd";

const ConversationSummary = ({
  conversationSummary,
  fetchApiByFilter,
  setStartDate,
  setEndDate,
}) => {
  // const fetchApiByFilter = (filter) => {
  //   switch (filter) {
  //     case "Last 7 days":
  //       break;
  //     case "This Month":
  //       break;
  //     case "This Year":
  //       break;
  //     case "Custom":
  //       break;
  //     default:
  //       break;
  //   }
  // };

  return (
    <div className="bg-white rounded-[1vw]  py-[1vw] px-[2vw] max-h-auto">
      <div className="flex-row justify-between items-center border-b-[1px] border-[var(--border-input)] pb-2">
        <p className="flex-row items-center font18px-500 text-[var(--textBlack)]">
          Conversation Summary
          {/* <div className="ml-2 pointer">
            <img src={ICONS?.homeDownload} className="w-[18px] h-[18px]" />
          </div> */}
        </p>

        <FilterHome
          fetchApiByFilter={fetchApiByFilter}
          filterList={HomeFilterList}
          setStartDate={setStartDate}
          setEndDate={setEndDate}
        />
      </div>

      <div className="w-100 flex-row align-center pt-[25px] pb-10 text-[var(--textBlack)]">
        {conversationSummaryList?.map((item) => (
          <div
            key={item?.id}
            className="w-100 flex-col justify-between border-r-[1px] border-[var(--border-input)] last:border-r-0"
          >
            <div className=" gap-1.5 flex-row justify-center items-center">
              <img
                src={item?.img}
                alt="summary"
                className="w-[1.8vw] h-[1.8vw]"
              />
              <span className="font15px-400 text-[var(--font-600)]">
                {item?.label}
              </span>
              <Tooltip title={item?.content}>
                <img
                  src={ICONS?.conversationAction}
                  alt="conversationAction"
                  className="w-[18px] h-[18px] mr-10 pointer"
                />
              </Tooltip>
            </div>
            <div className="flex-row justify-center">
              <span className="!mt-[0.8vw] font22px-600 text-[var(--textBlack)]">
                {conversationSummary?.[item?.key] || 0}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ConversationSummary;
